import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1021e740"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comment-template" }
const _hoisted_2 = { class: "comment-template__title" }
const _hoisted_3 = {
  key: 0,
  class: "comment-template__text"
}
const _hoisted_4 = { class: "comment-template__buttons" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Вставить ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Редактировать ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Сохранить ")

import { ref } from 'vue'
import { CommentTemplateType } from '@/shared/types'
import { ElMessage } from 'element-plus'
import { commentApi } from '@/shared/api'
import { showErrorMessage } from '@/shared/utils'

interface Props {
  commentTemplate: CommentTemplateType
  commentIndex: number
}


export default /*#__PURE__*/_defineComponent({
  props: {
    commentTemplate: null,
    commentIndex: null
  },
  emits: ['insert-comment'],
  setup(__props: any, { emit }) {

const props = __props as {
  commentTemplate: CommentTemplateType
  commentIndex: number
}




const isEditMode = ref(false)

const newCommentTemplate = ref<CommentTemplateType>({
  template_id: props.commentTemplate.template_id,
  template: props.commentTemplate.template,
  isVisible: false,
})

const showStatusMessage = (error): void => {
  if (error) {
    showErrorMessage(error)
  } else {
    ElMessage({
      message: 'Шаблон сохранен',
      type: 'success',
    })
  }
}

const handleTemplateEdit = (): void => {
  isEditMode.value = true
}

const handleTemplateInsert = (): void => {
  emit('insert-comment', newCommentTemplate.value)
}

const handleTemplateSave = async (): Promise<void> => {
  if (newCommentTemplate.value.template_id === 0) {
    const [error] = await commentApi.addCommentTemplate(
      newCommentTemplate.value.template
    )

    showStatusMessage(error)
  } else {
    const [error] = await commentApi.editCommentTemplate(
      newCommentTemplate.value
    )

    showStatusMessage(error)
  }

  isEditMode.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, "Шаблон " + _toDisplayString(__props.commentIndex), 1),
    (!isEditMode.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(newCommentTemplate.value.template), 1))
      : (_openBlock(), _createBlock(_component_el_input, {
          key: 1,
          modelValue: newCommentTemplate.value.template,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newCommentTemplate.value.template) = $event)),
          class: "comment-template__input",
          type: "textarea"
        }, null, 8, ["modelValue"])),
    _createElementVNode("div", _hoisted_4, [
      (!isEditMode.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_el_button, {
              class: "comment-template__buttons-save",
              type: "primary",
              round: "",
              onClick: handleTemplateInsert
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              class: "comment-template__buttons-edit",
              round: "",
              onClick: handleTemplateEdit
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ], 64))
        : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            class: "comment-template__buttons-save",
            type: "primary",
            round: "",
            onClick: handleTemplateSave
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }))
    ])
  ]))
}
}

})